import FormViewModal from 'components/common/Modals/FormViewModal';
import React from 'react';
import { IUpdateDueDatesDialogProperties } from './UpdateDueDatesDialog.properties';
import UpdateDueDateFormSchema from './UpdateDueDatesDialog.form';
import { usePOContextSelector, usePODispatch } from 'components/PurchaseOrders/PurchaseOrders.context';
import moment from 'moment';

const UpdateDueDatesDialog = (props: IUpdateDueDatesDialogProperties) => {
    const { open, loading, values, isProcessing,  onCancel, onOk, changeFormFieldValue } = props;
    const POSummary = usePOContextSelector<'SummaryPanelData'>((state) => state.SummaryPanelData);
    const contextDispatch = usePODispatch();
    const SpecificDueDateRef = React.useRef<HTMLInputElement>();

    return (
        <div>
            <FormViewModal
                open={open}
                loading={loading || !POSummary}
                title='Update Due Dates'
                dialogActionsButtons={true}
                dialogActionsShadow={false}
                formProps={{
                    style: { height: '250px', width: '400px' },
                    formSchema: UpdateDueDateFormSchema,
                    initialValues: {
                        DueDateOption: 'A',
                        SpecificDueDate: ''
                    },
                    valuesSchema: {},
                    fieldExtensions: {
                        SpecificDueDate: {
                            disabled: values?.DueDateOption === 'A',
                            required: values?.DueDateOption !== 'A',
                            fieldRef: (Ref) => SpecificDueDateRef.current = Ref
                        },
                        DueDateOption: {
                            onChange: (v) => {
                                if (v[0] === 'S') {
                                    setTimeout(
                                        () => {
                                            SpecificDueDateRef.current?.focus();
                                        },
                                        0
                                    );

                                } else {
                                    changeFormFieldValue('SpecificDueDate', '');
                                }
                            }
                        }
                    }
                }}
                actions={[
                    {
                        title: 'Ok',
                        isDefault: true,
                        disabled: isProcessing,
                        listener: () => {
                            if (onOk) {
                                if (values?.DueDateOption === 'S' && moment(values?.SpecificDueDate, 'DD/MM/YYYY', true)?.isValid()) {
                                    onOk(values);
                                } else if (values?.DueDateOption === 'A') {
                                    onOk({
                                        ...values,
                                        SpecificDueDate: null
                                    });
                                }
                            }
                        }
                    },
                    {
                        title: 'Cancel',
                        listener: () => {
                            if (onCancel) {
                                contextDispatch({ setProcessPurchaseOrderDetails: { Action: null, UserId: null, Pin: null } });
                                onCancel();
                            }
                        },
                    },
                ]}
            />
        </div>
    );
};

export default UpdateDueDatesDialog;
